var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.195,
    height: 320.508,
    viewBox: "0 0 226.195 320.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(180.555 330.105) rotate(-161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302",
    transform: "translate(163.501 141.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M12.119,14.628,0,55.656,40.648,33.139,55.512,82.815l-.165.021a.448.448,0,0,1-.013.046c-.469,1.466-10.032,12.238-13.5,16.364a2.287,2.287,0,0,0,.605,3.347,2.637,2.637,0,0,0,3.178-.022L49.7,99.411l-3.33,17.863a2.568,2.568,0,0,0,1.99,2.994,2.215,2.215,0,0,0,2.6-1.6l3.032-11.161.922.029-.259,14.889A2.552,2.552,0,0,0,57,125.052a2.2,2.2,0,0,0,2.324-1.877l2.2-15.443.738.02L63.263,121a2.8,2.8,0,0,0,2.8,2.605,2.437,2.437,0,0,0,2.369-2.518L68.282,107.9c.113,0,.227.006.34.006l2.618,10.615A2.262,2.262,0,0,0,73.5,120.3a1.982,1.982,0,0,0,1.883-2.094l-1.851-10.181S75.4,90.861,71.854,84.538a2.714,2.714,0,0,0-1.07-.993C70.313,60.016,61.892,22.6,59.379,11.93,58.392,6.554,55.946,1.056,50.15.146A13.073,13.073,0,0,0,48.121,0C35.568,0,12.119,14.628,12.119,14.628Z",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M0,6.029S7.366,9.932,12.281,0",
    transform: "translate(50.641 92.653)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.183
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295",
    transform: "translate(0 10.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M.034,0c-1.184,7.913,28.5,14.747,28.5,14.747L45.113,126.433l31.021.955L46.483,12.739C49.876,1.043,36.227,0,36.227,0Z",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M0,53.508V2.641L45.939,1.463V37.9l9.916,1.729L62.521,2.641,104.079,0,87.9,76.362Z",
    transform: "translate(82.706 0)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M40.954,67.5,0,82.223c20.4,54.9,57.121,52.02,57.31,52v0l42.628,7.593s25.17,16.7,64.31-9.481L141.284,96.011l-5.772.534,12.072-82.108L46.239,0Z",
    transform: "translate(31.889 51.992)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303",
    transform: "translate(70.152 119.494)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 2.693,
    y2: 24.655,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x1: 3.903,
    y2: 21.285,
    transform: "translate(93.346 29.043)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311",
    transform: "translate(74.373 177.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M7.833,14.223h0L3.14,42.82,29.5,47.147l4.693-28.6,8.435-2.29S42.733,4.106,23.312.649,0,8.665,0,8.665Z",
    transform: "translate(14.825 0)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M26.317,14.636S25.876,3.4,16.259.542C5.19-2.75,0,10.033,0,10.033s5.985-5.207,13.886-3.92A17.683,17.683,0,0,1,26.317,14.636Z",
    transform: "translate(19.493 24.472)",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M0,29.4s4.692,11.621,20.47,9.709c11.136-1.349,14.858-10.43,16.821-14.564a10.152,10.152,0,0,0,.963-5.075L36.09,0,17.613,24.808,2.394,22.066Z",
    transform: "translate(14.24 59.638)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M13.513,9.573a31.269,31.269,0,0,0-2.632,5.5l0-.012A4.929,4.929,0,0,0,7.03,13.629C.715,14.289-2.146,24.122,1.822,26.1A4.966,4.966,0,0,0,8.107,25.09c.038-.2.085-.429.139-.674A93.253,93.253,0,0,0,6.7,34.435S4.554,56.007,25.874,58.13C48.329,60.363,49.8,38.836,49.8,38.836a106.194,106.194,0,0,0,.52-10.623c.013.4.019.77.014,1.078a4.964,4.964,0,0,0,5.965,2.224c4.279-1.155,3.408-11.354-2.651-13.247a4.932,4.932,0,0,0-3.949.565,31.976,31.976,0,0,0-1.6-6.6C45.313,4.849,40.914,1.229,33.379.252A28.662,28.662,0,0,0,29.7,0C23.6,0,18.036,2.321,13.513,9.573Z",
    transform: "translate(0 30.348)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306",
    transform: "translate(50.31 53.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M5.516,4.522S1.947,5.331,0,0",
    fill: "none",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.698
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309",
    transform: "translate(2.992 49.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M0,3.347S3.34,4.844,6.3,0",
    fill: "none",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.698
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M5.952,0,.237,18.569a8.176,8.176,0,0,0,.2,4.6c1.278,3.7,5.2,12,11.648,10.438l2.394-7.338s-7.755-2.385-9.9-13.054Z",
    transform: "translate(2.155 55.438)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M0,10.82S14.254-3.319,39.44.728c0,0-4.222,18.042-16.062,18.169A41.376,41.376,0,0,1,2.265,12.881Z",
    transform: "translate(11.759 71.887)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M10.443,15.715A38.6,38.6,0,0,0,.387,0S-3.029,17.018,10.443,15.715Z",
    transform: "translate(6.191 65.989)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310",
    transform: "translate(10.704 41.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M.024,1.612A1.907,1.907,0,1,1,1.611,3.791,1.905,1.905,0,0,1,.024,1.612Z",
    transform: "translate(25.59 16.839)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M.023,1.611a1.907,1.907,0,1,1,1.588,2.18A1.908,1.908,0,0,1,.023,1.611Z",
    transform: "translate(7.929 14.065)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M12.151,5.262,0,0S.018,3.643,5,5.748,12.151,5.262,12.151,5.262Z",
    transform: "translate(0 19.805)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M0,1.282,13.179,0S12.045,3.463,6.661,3.939,0,1.282,0,1.282Z",
    transform: "translate(21.056 25.021)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M0,3.559.55.879a1.067,1.067,0,0,1,1.455-.8L3.37.674",
    transform: "translate(17.749 9.025)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M0,3.763l13.716,3.1S14.844,1.528,8.094.223,0,3.763,0,3.763Z",
    transform: "translate(13.781 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.29375165cc5cec2fd580092bbe992322.svg";
export { ForwardRef as ReactComponent };